import user from './user';
import teacher from './teacher';
import school from './school';
import manager from "./manager";
import backstage from "./backstage";
import exam from "./exam";

export default [
    user,
    exam,
    teacher,
    school,
    manager,
    backstage
]
